import { useEffect, useState } from 'react';
import { ApiConsumer, Backend } from 'api/ApiConsumer';
import { MusicChart } from 'components/Music/chart';

export function ChartTable({ url, useNewAPI = false }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (useNewAPI == false) {
      setLoading(true);
      ApiConsumer.get(url)
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => console.error('new channel top api error', err))
        .finally(() => setLoading(false));
    } else {
      setLoading(true);
      Backend.get(url)
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => console.error('new channel top api error', err))
        .finally(() => setLoading(false));
    }
  }, []);

  return (
    <>
      <MusicChart list={data} limit={5} loading={loading} report={true} />
    </>
  );
}
